<template>
  <div>
    <button v-if="params.data.last_adt_correlation_id" class="prime-button button-secondary button-block"
      @click="onClick()">
      <span class="text-black">
        {{ params.value }}
      </span>
    </button>
    <span v-else>
      {{ params.value }}
    </span>
  </div>
</template>

<script>
import ModalEventNotification from "@/components/Settings/Patient/ModalEventNotification";
import { engageFhirApi } from "../../../services/EngageFhirApi";
import { getPrimeEncounter } from "../../Settings/Patient/EventNotification";

export default {
  name: "EventsRenderer",
  data() {
    return {
      params: null
    };
  },
  beforeMount() {
    this.params = this.params;
  },
  components: {},
  methods: {
    async onClick() {
      const details = await this.getPrimeAdtDetails(this.params.data.last_adt_correlation_id);
      this.openModal(details, this.params.data.beneficiaryid);
    },
    async getPrimeAdtDetails(id) {
      const primeAdtEncounterSummary = await this.primeAdtEncounterLoad(this.params.data.beneficiaryid, parseInt(id, 10));
      const primeEncounterDetail = getPrimeEncounter(primeAdtEncounterSummary);
      const detailsObj = primeEncounterDetail.length > 0 ? primeEncounterDetail[0] : {};
      return detailsObj;
    },
    openModal(detailsObj, beneId) {
      this.$ionic.modalController
        .create({
          component: ModalEventNotification,
          mode: "ios",
          componentProps: {
            propsData: {
              detailsObj,
              beneId
            }
          },
          backdropDismiss: false
        })
        .then(m => m.present());
    },
    async primeAdtEncounterLoad(beneficiary, encounterId) {
      const payload = {
        patientId: beneficiary,
        daysInterval: 30,
        encounterId: encounterId,
        eventFilters: ["A01", "A03", "A04"]
      };
      try {
        return await engageFhirApi.post(`/AdtHl7FhirBundle/search`, payload);
      } catch (error) {
        this.isADTsLoading = false;
        if ([error?.status, error?.statusCode].includes(404)) {
          khanSolo.log(`No ADT found for beneficiary ${beneficiary}`);
        } else {
          khanSolo.error(`Error fetching ADT for beneficiary ${beneficiary} with encounterId ${encounterId}:`, error);
          khanSolo.error(error);
        }
        return [];
      }
    },
  }
};
</script>
